import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import BaseDetails from 'containers/Base/BaseDetails';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import staticText from 'static/text_display.json';
import { translatedKeyValueText } from 'utils/methods/helpers';
import { closeDetails, openDetails, toggleModal } from 'reducers/ui';
import { assetGridActions, assetSelectors, assetNS } from '../';
import { PAGE_URLS } from 'utils/constants';

const AssetDetails = ({
  id,
  cancel,
  editable,
  operationComponent,
  FormComponent,
  showConfirmPopup,
  closeConfirmPopup,
  toggleEditMode,
  loading,
}) => {
  // selectors-------------------
  const assetDetail = useSelector(
    state => assetSelectors.getAssetDetailsTransformed(state),
    shallowEqual,
  );
  // actions---------------------
  const dispatch = useDispatch();
  const dispatchOpenDetails = useCallback(
    url => {
      dispatch(openDetails(url));
    },
    [dispatch],
  );
  const dispatchCloseDetails = useCallback(
    url => {
      dispatch(closeDetails(url));
    },
    [dispatch],
  );
  const dispatchSetAssetId = useCallback(
    id => {
      dispatch(assetGridActions.setSelectedRowID(id));
    },
    [dispatch],
  );
  const dispatchFetchDetailsAction = useCallback(
    id => {
      dispatch(assetGridActions.fetchGridRowDetails({ id }));
    },
    [dispatch],
  );
  const dispatchToggleModal = useCallback(
    assetNS => dispatch(toggleModal(assetNS)),
    [dispatch],
  );
  //----------------------------Hooks--------------

  useEffect(() => {
    if (id) {
      dispatchFetchDetailsAction(id);
      dispatchOpenDetails(PAGE_URLS.ASSETS.link);
      dispatchSetAssetId(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onEdit = () => {
    toggleEditMode();
    dispatchToggleModal(assetNS);
  };

  const onCancel = () => {
    cancel();
    dispatchCloseDetails(PAGE_URLS.ASSETS.link);
    dispatchSetAssetId(null);
  };
  return (
    <BaseDetails
      header={staticText.managerial_view.asset.details}
      loading={loading}
      details={assetDetail}
      cancel={onCancel}
      editable={editable}
      onEdit={onEdit}
      operationComponent={operationComponent}
      FormComponent={FormComponent}
      showConfirmPopup={showConfirmPopup}
      closeConfirmPopup={closeConfirmPopup}
      editHoverText={
        assetDetail && Object.keys(assetDetail).length > 0
          ? translatedKeyValueText('edit_value_title', {
              message: staticText.general.edit_value,
              value: assetDetail.generalInfo.assetName.value,
            })
          : staticText.managerial_view.asset.edit_default
      }
    />
  );
};

AssetDetails.propTypes = {
  id: PropTypes.string,
  cancel: PropTypes.func,
  editable: PropTypes.bool,
  assetDetail: PropTypes.elementType,
  operationComponent: PropTypes.node,
  FormComponent: PropTypes.elementType,
  showConfirmPopup: PropTypes.bool,
  loading: PropTypes.bool,
  closeConfirmPopup: PropTypes.func,
  toggleEditMode: PropTypes.func,
};

export default AssetDetails;
